import React from 'react';

interface ColumnContextProps {
    siteId: string;
}

export const ColumnContext = React.createContext<ColumnContextProps>({
    siteId: '',
});
